import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      width: '0.3em',
      height: '0.3em',
      // color: '#194579',
      color: theme.palette.primary.main,
    },
    marginBottom: theme.spacing(1),
  },
  typography: {
    fontSize: '1.6em',
    fontWeight: 700,
    fontFamily: 'Roboto',
    // color: '#194579',
    color: theme.palette.primary.main,
    paddingLeft: theme.spacing(1),
  },
});

class SubTitle extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        {!this.props.isDecoHidden && <FiberManualRecordIcon />}
        <Typography className={classes.typography}>{this.props.children}</Typography>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SubTitle);
